module.exports = __webpack_public_path__ + "assets/88cec5fb9342ba3a8f77392562c61992.json";